// extracted by mini-css-extract-plugin
export default {"videoContainer":"LightboxModal_videoContainer__YuICa","video":"LightboxModal_video__jfK1U"};